/*
 * @Author: caoshuai 63615488@qq.com
 * @Date: 2022-09-20 19:38:42
 * @LastEditors: caoshuai 63615488@qq.com
 * @LastEditTime: 2022-10-11 16:46:17
 * @FilePath: /pscd-portal-www/packages/clients/controller/account/customer.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**
 * @desc 我区域的客户
 */
import { EnumAPI } from '../../apis';
import { BasesController } from '../bases';
export class CustomerController<T = any> extends BasesController<T> {
  constructor() {
    super({
      dataKey: 'mobilePhone',
      infinite: true,
      pagination: EnumAPI.bffsvr_regionPage_list,
      paginationParams: {
        currentKey: 'curPageNo',
        pageSizeKey: 'pageSize',
        filterKey: 'search',
        response: {
          dataSource: 'recordList',
          total: 'recordCount',
        },
      },
    });
  }
}
